import { RefObject, useCallback, useEffect, useState } from 'react'
import { usePrevious } from 'react-use'

interface IsVisibleOnScreenHook {
  isVisible: boolean
  wasVisible?: boolean
}

export function useIsVisibleOnScreen(
  ref: RefObject<HTMLElement> | null,
  containerRef: RefObject<HTMLElement> | null,
): IsVisibleOnScreenHook {
  const [isVisible, setIsVisible] = useState(false)
  const wasVisible = usePrevious(isVisible)

  const checkInView = useCallback(() => {
    const element = ref?.current
    if (!element) {
      return
    }
    const rect = element.getBoundingClientRect()
    setIsVisible(rect.top < window.innerHeight && rect.bottom >= 0)
  }, [ref])

  useEffect(() => {
    checkInView()
  }, [checkInView])

  useEffect(() => {
    const container = containerRef?.current

    container?.addEventListener('scroll', checkInView)
    return () => {
      container?.removeEventListener('scroll', checkInView)
    }
  }, [checkInView, containerRef])

  return {
    isVisible,
    wasVisible,
  }
}
